
import { CheckCircle, Target, User, X } from 'lucide-react';
import { useState } from 'react';
import './ApprovalModal.scss';

const ApprovalModal = ({
  isOpen,
  onClose,
  assessment,
  employeeName,
  onConfirm,
  isLoading = false
}) => {
  const [feedback, setFeedback] = useState('');

  if (!isOpen || !assessment) return null;

  const handleConfirm = () => {
    if (!isLoading) {
      onConfirm(feedback.trim() || undefined);
      setFeedback('');
    }
  };

  return (
    <div className="approval-modal-overlay">
      <div className="approval-modal-backdrop" onClick={onClose} />
      <div
        className="approval-modal approval-modal--centered"
        onClick={e => e.stopPropagation()}
      >
        <div className="approval-modal-header">
          <div>
            <div className="approval-modal-title">
              <CheckCircle className="icon-xs icon-green" />
              <span>Aprovar Autoavaliação</span>
            </div>
            <div className="approval-modal-subtitle">Confirme a aprovação da autoavaliação</div>
          </div>
          <button onClick={onClose} className="approval-modal-close">
            <X className="icon-xs" />
          </button>
        </div>
        <div className="approval-modal-summary">
          <div className="approval-modal-row">
            <User className="icon-xs icon-blue" />
            <span className="label">Colaborador:</span>
            <span className="value">{employeeName}</span>
          </div>
          <div className="approval-modal-row">
            <Target className="icon-xs icon-green" />
            <span className="label">Competência:</span>
            <span className="value">{assessment.competencyName}</span>
          </div>
          <div className="approval-modal-row">
            <span className="label">Autoavaliação:</span>
            <span className="score">{assessment.selfScore}<span className="score-suffix">/{assessment?.expectedScore || '-'}</span></span>
          </div>
        </div>
        <div className="approval-modal-feedback">
          <label>Feedback (opcional)</label>
          <textarea
            value={feedback}
            onChange={e => setFeedback(e.target.value)}
            placeholder="Adicione comentários ou reconhecimento para o colaborador..."
            maxLength={500}
          />
        </div>
        <div className="approval-modal-actions">
          <button
            onClick={onClose}
            className="approval-cancel-btn"
            disabled={isLoading}
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            className="approval-confirm-btn"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="spinner"></div>
                <span>Aprovando...</span>
              </>
            ) : (
              <>
                <CheckCircle className="icon-xs icon-green" />
                <span>Confirmar Aprovação</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApprovalModal;